export const parseUrlSearch = (search: string) => {
  const urlSearchParams = new URLSearchParams(search);
  return Object.fromEntries(urlSearchParams.entries());
};

export const getUrlSearchParam = (search: string, value: string) =>
  new URLSearchParams(search).get(value) || '';
